import { makeStyles } from '@material-ui/core'

import { storeStatusStatusOpts as SSSOpts } from '../constants'

import type { TpStoreStatusStatus } from '../types'
import Colors from '../../../constants/Colors'

export default makeStyles(theme => ({
  listItem: {
    alignItems: 'flex-start',
    [theme.breakpoints.up('sm')]: {
      padding: '0.5rem 2rem',
    },
    [theme.breakpoints.up('md')]: {
      alignItems: 'center',
      padding: '0.5rem 1rem',
    },
  },
  itemIcon: {
    minWidth: '3rem',
    marginTop: '0.25rem',
    [theme.breakpoints.up('md')]: {
      minWidth: '2.25rem',
      margin: 0,
    },
  },
  icon: (props: { state: TpStoreStatusStatus }) => ({
    fontSize: '2rem',
    color: SSSOpts[props.state]?.bgColor ?? '',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.25rem',
    },
  }),
  rootText: {
    margin: 0,
  },
  primaryText: {
    fontSize: '1.125rem',
    lineHeight: 1.5,
    fontWeight: 600,
    color: Colors.SHIP_GRAY,
    [theme.breakpoints.up('md')]: {
      fontSize: '0.75rem',
    },
  },
  secondaryText: {
    fontSize: '1rem',
    lineHeight: 1.5,
    color: Colors.JUMBO,
    [theme.breakpoints.up('md')]: {
      fontSize: '0.75rem',
      lineHeight: 1.25,
    },
  },
}))
